import React from 'react';
import CalculationErrorMessage from '~/components/Tools/CalculateMaximumMortgage/CalculationErrorMessage';
import CalculationResult from '~/components/Tools/CalculateMaximumMortgage/CalculationResult';
import NoCalculationMessage from '~/components/Tools/CalculateMaximumMortgage/NoCalculationMessage';
import { useCalculateMaximumMortgageCalculation } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/CalculationContext';

const CalculationResultWrapper: React.FC = () => {
  const { isCalculating, isError, selected } =
    useCalculateMaximumMortgageCalculation();

  if (isError) {
    return <CalculationErrorMessage />;
  }

  if (!isCalculating && !selected) {
    return <NoCalculationMessage />;
  }

  return <CalculationResult />;
};

export default CalculationResultWrapper;
